function prepareFilters(filterData) {
    let params = {}
    filterData.forEach(filter => {
        if (filter.value !== '') {
            params[`${filter.label}${filter.lookup}`] = filter.value
        }
    })
    return params
}

export {prepareFilters}